import axios from "axios";
import axiosInstance from "@/lib/axios";
import { withRetry } from "@/lib/retry";
import { BASE_URL } from "@/lib/axios";
import { serverFetch } from "@/lib/serverFetch";
import type {
  SeriesQueryParams,
  SeriesResponse,
  ApiErrorResponse,
  SeriesDetail,
  EpisodesBySeasonResponse,
  SeriesSeasonsResponse,
} from "@/types/series";

const SERIES_URL = "/series";

export const getSeries = async (
  params?: SeriesQueryParams
): Promise<SeriesResponse> => {
  try {
    const { data } = await axiosInstance.get(SERIES_URL, {
      params,
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
};

export const getSeriesByUuid = async (
  uuid: string,
  accessToken?: string | null,
): Promise<{ data: SeriesDetail; succeed: boolean }> => {
  return withRetry(async () => {
    const { data } = await axios.get(`${BASE_URL}${SERIES_URL}/${uuid}`, {
      headers: accessToken ? { Authorization: accessToken } : {},
      timeout: 30000,
    });
    return data;
  });
};


export const getSeriesByCodeCached = async (
  code: string,
): Promise<{ data: SeriesDetail; succeed: boolean }> => {
  return serverFetch<{ data: SeriesDetail; succeed: boolean }>(
    `${SERIES_URL}/by-code/${code}`,
    { revalidate: 3600, tags: ["series"] },
  );
};

export const getSeriesByCode = async (
  code: string,
  accessToken?: string | null,
): Promise<{ data: SeriesDetail; succeed: boolean }> => {
  return withRetry(async () => {
    const { data } = await axios.get(`${BASE_URL}${SERIES_URL}/by-code/${code}`, {
      headers: accessToken ? { Authorization: accessToken } : {},
      timeout: 30000,
    });
    return data;
  });
};

export const getSeriesSeasonsByCode = async (
  code: string,
): Promise<SeriesSeasonsResponse> => {
  try {
    const { data } = await axiosInstance.get(`${SERIES_URL}/by-code/${code}/seasons`, {
      withCredentials: true,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
};

export const getEpisodesBySeasonUuid = async (
  seasonUuid: string,
): Promise<EpisodesBySeasonResponse> => {
  try {
    const { data } = await axiosInstance.get("/episodes", {
      params: { season_uuid: seasonUuid, limit: 100 },
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError?.(err)) {
      const apiError = err.response?.data as ApiErrorResponse;
      throw apiError;
    }
    throw err;
  }
};
